import React from 'react';
import { StyleSheet, View, Text, TouchableOpacity } from 'react-native';
import { EditIcon } from '../../../../resources/svgComponents/EditIcon';
import { RemoveIcon } from '../../../../resources/svgComponents/RemoveIcon';
import { UserItemToDisplayType } from './utils';
import CoinIcon from '../../../../resources/svgComponents/CoinIcon';
import Eye from 'react-native-vector-icons/FontAwesome';
import { useGetHivesQuery } from '../../MyHives/useGetHivesQuery.gql';

const UserItem = ({
  user,
  index,
  editAction,
  removeAction,
  rangeQuery,
  navigation,
  hiveId,
}: UserItemToDisplayType) => {
  return (
    <View style={[styles.row, index === 0 ? { borderTopWidth: 0 } : null]}>
      <View style={styles.rowView}>
        <Text style={styles.rowText}>{user.lastName}</Text>
      </View>
      <View style={styles.rowView}>
        <Text style={styles.rowText}>{user.firstName}</Text>
      </View>
      <View style={styles.rowView}>
        <Text style={styles.rowText}>{user.userName}</Text>
      </View>
      <View style={styles.rowView}>
        <Text style={styles.rowText}>{user.password}</Text>
      </View>
      <View style={styles.rowView}>
        <Text style={styles.rowText}>{user.numberOfGames}</Text>
      </View>
      <View style={styles.rowView}>
        <Text style={styles.rowText}>{Math.round((user.totalTime ?? 0) / 60000)}</Text>
      </View>
      {!rangeQuery && (
        <View style={styles.rowView}>
          <View style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
            <CoinIcon />
            <Text style={[styles.rowText, { marginLeft: 5 }]}>{user.points}</Text>
          </View>
        </View>
      )}
      <View style={styles.rowViewLast}>
        <TouchableOpacity
          onPress={() => {
            navigation.navigate('HiveJourneys', {
              journey: true,
              userId: user.id,
              userName: user.userName,
              hiveId,
            });
          }}
          style={{ marginHorizontal: 10 }}
        >
          <Eye name={'eye'} size={20} color="#000000" />
        </TouchableOpacity>
        <TouchableOpacity onPress={editAction} style={{ marginHorizontal: 10 }}>
          <EditIcon />
        </TouchableOpacity>
        <TouchableOpacity onPress={removeAction} style={{ marginHorizontal: 10 }}>
          <RemoveIcon />
        </TouchableOpacity>
      </View>
      <Text />
    </View>
  );
};

export { UserItem };

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 20,
    borderTopColor: 'black',
    borderTopWidth: 1,
    backgroundColor: '#FFF5DD',
  },
  rowViewLast: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingHorizontal: 54,
  },

  rowText: {
    fontFamily: 'Inter',
    fontWeight: '600',
    fontSize: 14,
    alignSelf: 'flex-start',
    color: '#453B3B',
  },
  rowView: {
    flex: 1,
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
});
